import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const SkeletonHomePage: React.FC = () => {
    return (
        <Row>
            <Col className="d-none d-lg-block">
                <Skeleton count={2} height={500} />
            </Col>
            <Col xs={12} sm={12} md={12} lg={9}>
                <Row>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                    <Col>
                        <Skeleton height={150} />
                        <Skeleton height={100} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
